// extracted by mini-css-extract-plugin
module.exports = {"theme":"loyalty-points-theme-module__theme___LFePD"};